/* eslint-disable no-nested-ternary */
import React from 'react';
import { Col, Row } from 'antd';
import styled from 'styled-components';
import { SRIOverviewData } from 'Types/SRITypes';
import { boxShadow, scrollbar } from 'Utils/utilsStyle';
import EmptyState from 'Components/common/components/EmptyState';
import InfiniteScroll from 'react-infinite-scroll-component';
import EngagementSalesTrigger from './EngagementSalesTrigger';
import EngagementTitle from './EngagementTitle';
import EngagementProfile from './EngagementProfile';

const Wrapper = styled.div`

`;

const Scrollbar = styled.div<{ withoutBackground?: boolean }>`
  margin: 0px 5px 0 0px;
  padding-right: 10px;
  background: ${(props) => (props.withoutBackground ? '#fff' : '')};
  max-height: 540px;
  ${scrollbar};
`;

const Engagement = styled.div`
.overview-engagement-infinite {
  &.backgroundColor {
    background-color: #fff;
  }
  margin: 0px 5px 0 0px;
  padding-right: 10px;
  max-height: 540px;
  ${scrollbar};
}
 .ant-col {
   margin-bottom: 45px;
 }
`;

const Overlay = styled.div<{ withoutBackground?: boolean }>`
  box-shadow: ${boxShadow};
  border-radius: 10px;
  background: ${(props) => (props.withoutBackground ? '' : '#fff')};
  padding: 24px 14px;
  height: 540px;
`;

type Props = {
  companyLoading: boolean;
  personLoading: boolean;
  triggersLoading: boolean;
  fetchMoreCompanyLoading: boolean;
  fetchMorePersonLoading: boolean;
  overviewEngagementCompanies: SRIOverviewData[],
  overviewEngagementPersons: SRIOverviewData[],
  overviewEngagementTriggers: SRIOverviewData[]
  fetchMore: (filter: string) => void
} | typeof defaultProps;

const defaultProps = {
  companyLoading: false,
  personLoading: false,
  triggersLoading: false,
  fetchMoreCompanyLoading: false,
  fetchMorePersonLoading: false,
  overviewEngagementCompanies: [] as SRIOverviewData[],
  overviewEngagementPersons: [] as SRIOverviewData[],
  overviewEngagementTriggers: [] as SRIOverviewData[],
  fetchMore: () => { },
};

const OverviewEngagement: React.FC<Props> = function OverviewEngagement(props) {
  const {
    companyLoading, personLoading, triggersLoading, fetchMoreCompanyLoading, fetchMorePersonLoading,
    overviewEngagementCompanies, overviewEngagementPersons, overviewEngagementTriggers,
    fetchMore,
  } = props;

  const companies = overviewEngagementCompanies[0]?.results;
  const people = overviewEngagementPersons[0]?.results;
  const triggers = overviewEngagementTriggers[0]?.results;
  return (
    <Wrapper>
      <Engagement>
        <div className="head-wrap d-flex justify-content-between mb-c-20">
          <h6 className="title mb-0">ENGAGEMENT</h6>
        </div>
        <Row gutter={[16, 16]}>
          <Col span={8}>
            <EngagementTitle primaryHeading="Company" secondaryHeading="Views" />
            <InfiniteScroll
              dataLength={companies?.length || 0}
              next={() => fetchMore('company')}
              hasMore
              loader={false}
              className="o-x-hidden overview-engagement-infinite"
              height="auto"
            >
              {companyLoading
                ? Array.from(Array(6)).map(
                  () => <EngagementProfile loading={companyLoading} />,
                )
                : companies?.map((company) => (
                  <EngagementProfile
                    title={company.companyName}
                    image={company.companyLogo}
                    downloadsProfile={company.downloads}
                    count={company.views}
                    companyId={company.companyId}
                  />
                ))}
              {fetchMoreCompanyLoading && Array.from(Array(3)).map(
                () => <EngagementProfile loading={fetchMoreCompanyLoading} />,
              )}
            </InfiniteScroll>

            {companies && companies?.length === 0 && !companyLoading
              && (
                <Overlay>
                  <EmptyState
                    msg="No analytics data found"
                    detail="Try adjusting your filters to find what you are looking for"
                    height="500px"
                  />
                </Overlay>
              )}
          </Col>
          <Col span={8}>
            <EngagementTitle primaryHeading="People" secondaryHeading="Views" />
            <InfiniteScroll
              dataLength={people?.length || 0}
              next={() => fetchMore('person')}
              hasMore
              loader={false}
              className="o-x-hidden overview-engagement-infinite"
              height="auto"
            >
              {personLoading
                ? Array.from(Array(6)).map(
                  () => <EngagementProfile loading={personLoading} />,
                )
                : people?.map((person) => (
                  <EngagementProfile
                    personWidget
                    title={person.personName}
                    image={person.personImage}
                    downloadsProfile={person.downloads}
                    count={person.views}
                    personId={person.personId}
                    personality={person.personalityTypes}
                  />
                ))}
              {fetchMorePersonLoading && Array.from(Array(6)).map(
                () => <EngagementProfile loading={fetchMorePersonLoading} />,
              )}
            </InfiniteScroll>
            {people && people?.length === 0 && !personLoading
              && (
                <Overlay>
                  <EmptyState
                    msg="No analytics data found"
                    detail="Try adjusting your filters to find what you are looking for"
                    height="500px"
                  />
                </Overlay>
              )}
          </Col>
          <Col span={8}>
            <EngagementTitle primaryHeading="Sales Triggers" secondaryHeading="Articles" />
            <Scrollbar withoutBackground>
              {triggersLoading
                ? [1, 2, 3, 4, 5, 6].map(
                  () => <EngagementSalesTrigger loading={triggersLoading} />,
                )
                : triggers?.map((trigger) => (
                  <EngagementSalesTrigger
                    tagTitle={trigger.alert}
                    tagColor={trigger.color}
                    count={trigger.count}
                  />
                ))}
            </Scrollbar>
            {triggers && triggers?.length === 0 && !triggersLoading
              && (
                <Overlay>
                  <EmptyState
                    msg="No analytics data found"
                    detail="Try adjusting your filters to find what you are looking for"
                    height="500px"
                  />
                </Overlay>
              )}
          </Col>
        </Row>
      </Engagement>
    </Wrapper>
  );
};

export default OverviewEngagement;
